module.exports = __webpack_public_path__ + "img/roll-official-bg-DRp1UF5D.3fdf739c.png";